import i18nPackage from "../../i18n/i18n";
import VerityColorLogoSvg from "./images/verity-color.png";
import YujaWhiteLogoSvg from "./images/yuja-white.svg";
import YujaBlackLogoSvg from "./images/yuja-black.svg";
import YujaFullLogoSvg from "./images/yuja-full.svg";
import VerityLockdownLogoSvg from "./images/verity-lockdown.svg";
import VerityCircleSvg from "./images/verity-circle.svg";

function Logo(props: { height?: number; width?: number; src: string; style?: React.CSSProperties; alt?: string }) {
	return (
		<img
			height={props.height}
			width={props.width}
			src={props.src}
			draggable={false}
			alt={props.alt ?? ""}
			style={props.style}
		/>
	);
}

type LogoProps = {
	height?: number;
	width?: number;
	size?: "tiny" | "small" | "medium" | "large";
	style?: React.CSSProperties;
	applyBorder?: boolean;
	alt?: string;
};

function CoreLogo(props: {
	height?: number;
	width?: number;
	size?: "tiny" | "small" | "medium" | "large";
	src: string;
	style?: React.CSSProperties;
	alt?: string;
}) {
	const sizeDimensions = {
		tiny: { height: 12 },
		small: { height: 24 },
		medium: { height: 32 },
		large: { height: 54 },
		default: { height: 24 },
	};

	let dimensions: {
		height?: number;
		width?: number;
	} = sizeDimensions[props.size ?? "default"];

	if (props.height && props.width) {
		dimensions = { height: props.height, width: props.width };
	} else if (props.height) {
		dimensions = { height: props.height };
	} else if (props.width) {
		dimensions = { width: props.width };
	}

	return (
		<Logo height={dimensions.height} width={dimensions.width} src={props.src} style={props.style} alt={props.alt} />
	);
}

export function VerityColorLogo(props: Omit<LogoProps, "alt">) {
	return <CoreLogo {...props} src={VerityColorLogoSvg} alt={i18nPackage.t("coreComponents.logo.verityLogoAlt")} />;
}

export function YujaWhiteLogo(props: LogoProps) {
	return <CoreLogo {...props} src={YujaWhiteLogoSvg} />;
}

export function YujaBlackLogo(props: LogoProps) {
	return <CoreLogo {...props} src={YujaBlackLogoSvg} />;
}

export function VerityLockdownLogo(props: LogoProps) {
	return <CoreLogo {...props} src={VerityLockdownLogoSvg} />;
}

export function VerityLogoWithCircle(props: LogoProps) {
	const { applyBorder, style, ...rest } = props;
	const borderStyle = applyBorder
		? {
				borderRadius: "50%",
				boxShadow: "0 0 3.6px 0 #00000026",
			}
		: {};

	return <CoreLogo {...rest} src={VerityCircleSvg} style={{ ...borderStyle, ...style }} />;
}

export function YujaFullLogo(props: LogoProps) {
	return <CoreLogo {...props} src={YujaFullLogoSvg} />;
}
